import React from 'react';
import {Button } from '@material-ui/core'

export default class Test2 extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
            activ:true
}
    }

     componentDidMount(){
    }

    activate = () =>{
        this.setState(prevState =>({
            activ:!prevState.activ
        }))
    }
     render() { 
       return (
          <div>
              <TestComponent activ={this.state.activ} activate={this.activate}>
                  <TestComponentChild id={1}/>
                  <TestComponentChild id={2}/>
                  <TestComponentChild id={3}/>
              </TestComponent>
         </div>
        );
       }
}

class TestComponent extends React.Component {

    componentDidMount(){
        // console.log('this.props.children :', this.props.children);
    }
    render(){
        return (
            <div>
                <h1>Test component</h1>
                        <Button  onClick={this.props.activate}>
                        {this.props.activ ? 'Dezactivate' : 'Activate'}
                    </Button>

                <div>

                {this.props.activ ? this.props.children : <div><h2>Active false</h2></div> }
                </div>
                        

         
           
            </div>
        )
    }
}


class TestComponentChild extends React.Component{
    render(){
        return(
            <div>
            <h2>Active is true {this.props.id}</h2>
            </div>
        )
    }
}